export default __webpack_public_path__ + "static/media/997.267462b1.png";